import Vue from 'vue'
import Router from 'vue-router'
import shouye from '@/components/comment/shouye'
import login from '@/components/comment/login'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    mode: 'history',
    // base: '/web/',
    routes: [{
            path: '/',
            name: 'shouye',
            component: shouye,
            children: [ //crm
                //学员
                {
                    path: '/overview',
                    name: 'overview',
                    component: resolve => (require(["@/components/comment/overview"], resolve)),
                },
                {
                    path: '/mystudentlist',
                    name: 'mystudentlist',
                    component: resolve => (require(["@/components/mystudent/mystudentlist"], resolve)),
                },
                {
                    path: '/choicecouse',
                    name: 'choicecouse',
                    component: resolve => (require(["@/components/mystudent/choicecouse"], resolve)),
                },
                {
                    path: '/orderlist',
                    name: 'orderlist',
                    component: resolve => (require(["@/components/mystudent/orderlist"], resolve)),
                },
                {
                    path: '/incomemy',
                    name: 'incomemy',
                    component: resolve => (require(["@/components/mystudent/incomemy"], resolve)),
                },
                {
                    path: '/expendituremy',
                    name: 'expendituremy',
                    component: resolve => (require(["@/components/mystudent/expendituremy"], resolve)),
                },
                {
                    path: '/myachievement',
                    name: 'myachievement',
                    component: resolve => (require(["@/components/mystudent/myachievement"], resolve)),
                },
                {
                    path: '/classes',
                    name: 'classes',
                    component: resolve => (require(["@/components/mystudent/classes"], resolve)),
                },
                {
                    path: '/addcourse',
                    name: 'addcourse',
                    component: resolve => (require(["@/components/mystudent/studentpart/addcourse"], resolve)),
                },
                {
                    path: '/studentdesc',
                    name: 'studentdesc',
                    component: resolve => (require(["@/components/mystudent/studentpart/studentdesc"], resolve)),
                },
                {
                    path: '/studentselection',
                    name: 'studentselection',
                    component: resolve => (require(["@/components/mystudent/studentpart/studentselection"], resolve)),
                },
                {
                    path: '/tuiclass',
                    name: 'tuiclass',
                    component: resolve => (require(["@/components/mystudent/studentpart/tuiclass"], resolve)),
                },
                {
                    path: '/changeclass',
                    name: 'changeclass',
                    component: resolve => (require(["@/components/mystudent/studentpart/changeclass"], resolve)),
                },
                {
                    path: '/againpay',
                    name: 'againpay',
                    component: resolve => (require(["@/components/mystudent/studentpart/againpay"], resolve)),
                },
                {
                    path: '/coursemanger',
                    name: 'coursemanger',
                    component: resolve => (require(["@/components/crm/coursemanger"], resolve)),
                },
                {
                    path: '/discountpage',
                    name: 'discountpage',
                    component: resolve => (require(["@/components/crm/discountpage"], resolve)),
                },
                {
                    path: '/coursefree',
                    name: 'coursefree',
                    component: resolve => (require(["@/components/crm/coursefree"], resolve)),
                },
                {
                    path: '/classmanger',
                    name: 'classmanger',
                    component: resolve => (require(["@/components/crm/classmanger"], resolve)),
                }, {
                    path: '/coursesortoo',
                    name: 'coursesortoo',
                    component: resolve => (require(["@/components/crm/classpart/coursesortoo"], resolve)),
                }, {
                    path: '/coursesort',
                    name: 'coursesort',
                    component: resolve => (require(["@/components/crm/coursesort"], resolve)),
                }, {
                    path: '/trylisten',
                    name: 'trylisten',
                    component: resolve => (require(["@/components/crm/trylisten"], resolve)),
                }, {
                    path: '/onlinebook',
                    name: 'onlinebook',
                    component: resolve => (require(["@/components/crm/onlinebook"], resolve)),
                }, {
                    path: '/bookdelivery',
                    name: 'bookdelivery',
                    component: resolve => (require(["@/components/crm/bookdelivery"], resolve)),
                }, {
                    path: '/courselable',
                    name: 'courselable',
                    component: resolve => (require(["@/components/crm/courselable"], resolve)),
                },
                {
                    path: '/rechargeablecart',
                    name: 'rechargeablecart',
                    component: resolve => (require(["@/components/crm/rechargeablecart"], resolve)),
                },
                {
                    path: '/classzz',
                    name: 'classzz',
                    component: resolve => (require(["@/components/crm/classzz"], resolve)),
                },
                {
                    path: '/classzyjn',
                    name: 'classzyjn',
                    component: resolve => (require(["@/components/crm/classzyjn"], resolve)),
                },
                {
                    path: '/classzyll',
                    name: 'classzyll',
                    component: resolve => (require(["@/components/crm/classzyll"], resolve)),
                },
                {
                    path: '/classjnts',
                    name: 'classjnts',
                    component: resolve => (require(["@/components/crm/classjnts"], resolve)),
                },

                {
                    path: '/reportzz',
                    name: 'reportzz',
                    component: resolve => (require(["@/components/crm/reportzz"], resolve)),
                },
                {
                    path: '/reportzyjn',
                    name: 'reportzyjn',
                    component: resolve => (require(["@/components/crm/reportzyjn"], resolve)),
                },
                {
                    path: '/reportll',
                    name: 'reportll',
                    component: resolve => (require(["@/components/crm/reportll"], resolve)),
                },
                {
                    path: '/reportjnts',
                    name: 'reportjnts',
                    component: resolve => (require(["@/components/crm/reportjnts"], resolve)),
                }, {
                    path: '/reportingo',
                    name: 'reportingo',
                    component: resolve => (require(["@/components/crm/reportingo"], resolve)),
                },

                {
                    path: '/admin_list',
                    name: 'adminlist',
                    component: resolve => (require(["@/components/shop/adminlist"], resolve)),
                },
                {
                    path: '/role_list',
                    name: 'rolelist',
                    component: resolve => (require(["@/components/shop/rolelist"], resolve)),
                }, {
                    path: '/departmentlist',
                    name: 'departmentlist',
                    component: resolve => (require(["@/components/shop/departmentlist"], resolve)),
                },
                {
                    path: '/configurep',
                    name: 'configurep',
                    component: resolve => (require(["@/components/shop/configurep"], resolve)),
                },
                {
                    path: '/baseinfo',
                    name: 'baseinfo',
                    component: resolve => (require(["@/components/shop/baseinfo"], resolve)),
                },
                //payset
                {
                    path: '/payset',
                    name: 'payset',
                    component: resolve => (require(["@/components/shop/payset"], resolve)),
                },
                {
                    path: '/campuschool',
                    name: 'campuschool',
                    component: resolve => (require(["@/components/shop/campuschool"], resolve)),
                },
                {
                    path: '/addschool',
                    name: 'addschool',
                    component: resolve => (require(["@/components/shop/addschool"], resolve)),
                },
                {
                    path: '/partstructure',
                    name: 'partstructure',
                    component: resolve => (require(["@/components/shop/partstructure"], resolve)),
                },
                {
                    path: '/addadmin',
                    name: 'addadmin',
                    component: resolve => (require(["@/components/shop/shoppart/addadmin"], resolve)),
                }, {
                    path: '/addrole',
                    name: 'addrole',
                    component: resolve => (require(["@/components/shop/shoppart/addrole"], resolve)),
                }, {
                    path: '/authentication',
                    name: 'authentication',
                    component: resolve => (require(["@/components/shop/authentication"], resolve)),
                },
                {
                    path: '/timetable',
                    name: 'timetable',
                    component: resolve => (require(["@/components/crm/timetable"], resolve)),
                }, {
                    path: '/detalidtime',
                    name: 'detalidtime',
                    component: resolve => (require(["@/components/crm/detalidtime"], resolve)),
                }, {
                    path: '/coursecate',
                    name: 'coursecate',
                    component: resolve => (require(["@/components/crm/coursecate"], resolve)),
                }, {
                    path: '/studentlist',
                    name: 'studentlist',
                    component: resolve => (require(["@/components/crm/student/studentlist"], resolve)),
                }, {
                    path: '/checkwork',
                    name: 'checkwork',
                    component: resolve => (require(["@/components/crm/student/checkwork"], resolve)),
                },
                {
                    path: '/map',
                    name: 'map',
                    component: resolve => (require(["@/components/crm/student/map"], resolve)),
                },
                //教务管理-分类管理
                {
                    path: '/coursecateone',
                    name: 'coursecateone',
                    component: resolve => (require(["@/components/crm/fenlei/coursecateone"], resolve)),
                },
                {
                    path: '/coursecatetwo',
                    name: 'coursecatetwo',
                    component: resolve => (require(["@/components/crm/fenlei/coursecatetwo"], resolve)),
                },
                {
                    path: '/coursecatethree',
                    name: 'coursecatethree',
                    component: resolve => (require(["@/components/crm/fenlei/coursecatethree"], resolve)),
                },
                {
                    path: '/demonditu',
                    name: 'demonditu',
                    component: resolve => (require(["@/components/crm/demonditu"], resolve)),
                },
                //我的学员
                {
                    path: '/mystudentlist',
                    name: 'mystudentlist',
                    component: resolve => (require(["@/components/mystudent/mystudentlist"], resolve)),
                },
                {
                    path: '/balance',
                    name: 'balance',
                    component: resolve => (require(["@/components/mystudent/balance"], resolve)),
                },
                //审批设置 sendapproval
                {
                    path: '/setupapproval',
                    name: 'setupapproval',
                    component: resolve => (require(["@/components/approvalt/setupapproval"], resolve)),
                },
                {
                    path: '/sendapproval',
                    name: 'sendapproval',
                    component: resolve => (require(["@/components/approvalt/sendapproval"], resolve)),
                },
                {
                    path: '/approval',
                    name: 'approval',
                    component: resolve => (require(["@/components/approvalt/approval"], resolve)),
                },
                {
                    path: '/pendingapproval',
                    name: 'pendingapproval',
                    component: resolve => (require(["@/components/approvalt/pendingapproval"], resolve)),
                },
                //pendingapproval
                //进销存
                {
                    path: '/allstock',
                    name: 'allstock',
                    component: resolve => (require(["@/components/store/allstock"], resolve)),
                },
                {
                    path: '/warehousing',
                    name: 'warehousing',
                    component: resolve => (require(["@/components/store/warehousing"], resolve)),
                },
                {
                    path: '/warehousingout',
                    name: 'warehousingout',
                    component: resolve => (require(["@/components/store/warehousingout"], resolve)),
                },
                {
                    path: '/mystudentlistoo',
                    name: 'mystudentlistoo',
                    component: resolve => (require(["@/components/store/mystudentlistoo"], resolve)),
                },
                {
                    path: '/pandianshow',
                    name: 'pandianshow',
                    component: resolve => (require(["@/components/store/pandianshow"], resolve)),
                },
                {
                    path: '/goodlist',
                    name: 'goodlist',
                    component: resolve => (require(["@/components/store/goodlist"], resolve)),
                },
                {
                    path: '/basic',
                    name: 'basic',
                    component: resolve => (require(["@/components/store/basic"], resolve)),
                },
                {
                    path: '/supplier',
                    name: 'supplier',
                    component: resolve => (require(["@/components/store/supplier"], resolve)),
                },
                //财务
                {
                    path: '/revieworder',
                    name: 'revieworder',
                    component: resolve => (require(["@/components/caiwu/revieworder"], resolve)),
                },
                {
                    path: '/incomelist',
                    name: 'incomelist',
                    component: resolve => (require(["@/components/caiwu/incomelist"], resolve)),
                },
                {
                    path: '/expenditure',
                    name: 'expenditure',
                    component: resolve => (require(["@/components/caiwu/expenditure"], resolve)),
                },
                {
                    path: '/detailedlist',
                    name: 'detailedlist',
                    component: resolve => (require(["@/components/caiwu/detailedlist"], resolve)),
                },
                {

                    path: '/finance',
                    name: 'finance',
                    component: resolve => (require(["@/components/caiwu/finance"], resolve)),
                },
                {
                    path: '/eduorder',
                    name: 'eduorder',
                    component: resolve => (require(["@/components/caiwu/eduorder"], resolve)),
                },
                {
                    path: '/courseorder',
                    name: 'courseorder',
                    component: resolve => (require(["@/components/caiwu/courseorder"], resolve)),
                },

                //招生管理
                {
                    path: '/classreport',
                    name: 'classreport',
                    component: resolve => (require(["@/components/zhaosheng/classreport"], resolve)),
                },
                {
                    path: '/studentsall',
                    name: 'studentsall',
                    component: resolve => (require(["@/components/zhaosheng/studentsall"], resolve)),
                },
                {
                    path: '/choicecouseall',
                    name: 'choicecouseall ',
                    component: resolve => (require(["@/components/zhaosheng/choicecouseall"], resolve)),
                },
                {
                    path: '/orderlistall',
                    name: 'orderlistall ',
                    component: resolve => (require(["@/components/zhaosheng/orderlistall"], resolve)),
                },
                {
                    path: '/myachievementall',
                    name: 'myachievementall ',
                    component: resolve => (require(["@/components/zhaosheng/myachievementall"], resolve)),
                },
                //经营分析
                {
                    path: '/ustomeranalysis',
                    name: 'ustomeranalysis',
                    component: resolve => (require(["@/components/analysis/ustomeranalysis"], resolve)),
                },
                {
                    path: '/panalysis',
                    name: 'panalysis',
                    component: resolve => (require(["@/components/analysis/panalysis"], resolve)),
                },
                {
                    path: '/classanalysis',
                    name: 'classanalysis',
                    component: resolve => (require(["@/components/analysis/classanalysis"], resolve)),
                },
                //help
                {
                    path: '/helpcontent',
                    name: 'helpcontent',
                    component: resolve => (require(["@/components/help/helpcontent"], resolve)),
                },
                {
                    path: '/helpcat',
                    name: 'helpcat',
                    component: resolve => (require(["@/components/help/helpcat"], resolve)),
                },
                {
                    path: '/addhelpcontent',
                    name: 'addhelpcontent',
                    component: resolve => (require(["@/components/help/addhelpcontent"], resolve)),
                },
                //客户池
                {
                    path: '/commentpool',
                    name: 'commentpool',
                    component: resolve => (require(["@/components/pool/commentpool"], resolve)),
                },
                {
                    path: '/coustomerlog',
                    name: 'coustomerlog',
                    component: resolve => (require(["@/components/pool/coustomerlog"], resolve)),
                },
                {
                    path: '/recoverypool',
                    name: 'recoverypool',
                    component: resolve => (require(["@/components/pool/recoverypool"], resolve)),
                },
                {
                    path: '/telepool',
                    name: 'telepool',
                    component: resolve => (require(["@/components/pool/telepool"], resolve)),
                },



            ]

        },
        {
            path: '/login',
            name: 'login',
            component: login
        },

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js